document.addEventListener("DOMContentLoaded", (e) => {
  const getDataLakeCommonDetails = async (eventname, data) => {
    let user = 0;
    if (localStorage.getItem("customer")) {
      user = JSON.parse(localStorage.getItem("customer"));
    }
    return {
      data: {
        events: [
          {
            _id: crypto.randomUUID() + "-" + crypto.randomUUID(),
            eventName: eventname,
            eventParams: data,
            createdAt: new Date().getTime(),
            eventId: crypto.randomUUID() + "-" + crypto.randomUUID(),
            userId: user ? user?.metafields?.cult?.cfuserid : 0,
            sessionId: data.sessionId,
          },
        ],
        user: user
          ? {
              createdAt: new Date().getTime(),
              userId: user?.metafields?.cult?.cfuserid,
              userParams: {
                userId: user?.metafields?.cult?.cfuserid,
                firstName: user?.firstName,
                lastName: user?.lastName,
                email: user?.metafields?.cult?.email,
                phone: user?.phone,
                userName: user?.firstName + " " + user?.lastName,
                dob: user?.metafields?.cult?.dob,
              },
            }
          : 0,
        session: {
          sessionId: data.sessionId,
          createdAt: new Date().getTime(),
          sessionParams: {
            deviceId: data.deviceId,
            appTenant: "cultstore",
          },
        },
        device: {
          deviceId: data.deviceId,
          createdAt: new Date().getTime(),
          deviceParams: {
            deviceId: data.deviceId,
            appTenant: "cultstore",
            appVersion: localStorage.getItem("appVersion") ?? "",
          },
        },
        client: {
          headers: await fetch(document.URL, { method: "HEAD" })
            .then((response) => {
              let headers = {};
              for (const [key, value] of response.headers.entries()) {
                headers[key] = value;
              }
              return headers;
            })
            .catch((error) => console.error("Error fetching headers:", error)),
        },
      },
      ts_ms: new Date().getTime(),
    };
  };

  const trackDLEvent = async (eventName, event) => {
    const customData = {
      ...event.detail,
      // add more attriutes if required
    };
    const data = await getDataLakeCommonDetails(eventName, customData);
    Shopify.analytics.publish("DL_EVENTS", data);
  };

  //PAGE_VIEW
  document.addEventListener("PAGE_VIEW", async (event) => {
    await trackDLEvent("PAGE_VIEW", event);
  });

  // Subscribe to BUTTON_CLICK event
  document.addEventListener("BUTTON_CLICK", async (event) => {
    await trackDLEvent("BUTTON_CLICK", event);
  });

  // Subscribe to LINK_CLICK event
  document.addEventListener("LINK_CLICK", async (event) => {
    await trackDLEvent("LINK_CLICK", event);
  });

  // Subscribe to APPLY_SORT event
  document.addEventListener("APPLY_SORT", async (event) => {
    await trackDLEvent("APPLY_SORT", event);
  });

  // Subscribe to APPLY_FILTER event
  document.addEventListener("APPLY_FILTER", async (event) => {
    await trackDLEvent("APPLY_FILTER", event);
  });

  // Subscribe to CHECKOUT_CLICKED event
  document.addEventListener("CHECKOUT_CLICKED", async (event) => {
    let flattenedProductData = flattenCartItems(event.detail.cart.items);
    Object.keys(flattenedProductData).forEach((key) => {
      event.detail[key] = flattenedProductData[key];
    });
    event.detail.cartValue = event.detail.cart.total_price;
    event.detail.cartQuantity = event.detail.cart.item_count;
    await trackDLEvent("CHECKOUT_CLICKED", event);
  });

  // Subscribe to LOGIN_INITIATED event
  document.addEventListener("LOGIN_INITIATED", async (event) => {
    await trackDLEvent("LOGIN_INITIATED", event);
  });

  // Subscribe to LOGIN_STARTED event
  document.addEventListener("LOGIN_STARTED", async (event) => {
    await trackDLEvent("LOGIN_STARTED", event);
  });

  // Subscribe to OTP_SUBMITTED event
  document.addEventListener("OTP_SUBMITTED", async (event) => {
    await trackDLEvent("OTP_SUBMITTED", event);
  });

  // Subscribe to LOGIN_COMPLETED event
  document.addEventListener("LOGIN_COMPLETED", async (event) => {
    await trackDLEvent("LOGIN_COMPLETED", event);
  });

  // Subscribe to SEARCH event
  document.addEventListener("SEARCH", async (event) => {
    await trackDLEvent("SEARCH", event);
  });

  // Subscribe to VARIANT_SELECTED event
  document.addEventListener("VARIANT_SELECTED", async (event) => {
    event.detail.productSku = event.detail.selectedVariant.sku;
    event.detail.productName = event.detail.selectedVariant.name;
    event.detail.price = event.detail.selectedVariant.price;
    event.detail.compare_at_price =
      event.detail.selectedVariant.compare_at_price;
    event.detail.featured_image = event.detail.product.featured_image.src;

    await trackDLEvent("VARIANT_SELECTED", event);
  });

  // Subscribe to ATC (Add To Cart) event
  document.addEventListener("ATC", async (event) => {
    event.detail.productSku = event.detail.selectedVariant.sku;
    event.detail.productName = event.detail.selectedVariant.name;
    event.detail.price = event.detail.selectedVariant.price;
    event.detail.compare_at_price =
      event.detail.selectedVariant.compare_at_price;
    event.detail.featured_image = event.detail.product.featured_image.src;
    event.detail.productType = event.detail.product.productType;
    await trackDLEvent("ATC", event);
  });

  // Subscribe to CART_OPEN event
  document.addEventListener("CART_OPEN", async (event) => {
    let flattenedProductData = flattenCartItems(event.detail.cart.items);
    Object.keys(flattenedProductData).forEach((key) => {
      event.detail[key] = flattenedProductData[key];
    });
    event.detail.cartValue = event.detail.cart.total_price;
    event.detail.cartQuantity = event.detail.cart.item_count;
    await trackDLEvent("CART_OPEN", event);
  });

  // Subscribe to CART_CLOSE event
  document.addEventListener("CART_CLOSE", async (event) => {
    let flattenedProductData = flattenCartItems(event.detail.cart.items);
    Object.keys(flattenedProductData).forEach((key) => {
      event.detail[key] = flattenedProductData[key];
    });
    event.detail.cartValue = event.detail.cart.total_price;
    event.detail.cartQuantity = event.detail.cart.item_count;
    await trackDLEvent("CART_CLOSE", event);
  });

  // Subscribe to CART_UPDATE event
  document.addEventListener("CART_UPDATE", async (event) => {
    let flattenedProductData = flattenCartItems(event.detail.cart.items);
    Object.keys(flattenedProductData).forEach((key) => {
      event.detail[key] = flattenedProductData[key];
    });
    event.detail.cartValue = event.detail.cart.total_price;
    event.detail.cartQuantity = event.detail.cart.item_count;
    await trackDLEvent("CART_UPDATE", event);
  });

  document.addEventListener("checkout_completed", async (event) => {
    let checkoutCompletedEventData = {
      pageUrl: window.location.href,
      previousPageUrl: document.referrer,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      userAgent: navigator.userAgent,
      ...event.data,
    };

    await trackDLEvent("CHECKOUT_COMPLETED", checkoutCompletedEventData);
  });

  document.addEventListener("CHECKOUT_PROCESS", async (event) => {
    let { checkoutEvent, ...rest } = event.detail;
    let checkoutProcessEventData = {
      pageUrl: window.location.href,
      previousPageUrl: document.referrer,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      userAgent: navigator.userAgent,
      ...rest,
    };
    await trackDLEvent(checkoutEvent, { detail: checkoutProcessEventData });
  });

  document.addEventListener("LOGOUT", async (event) => {
    await trackDLEvent("LOGOUT", event);
  });
});
